<div class="demo-dialog-backdrop" *ngIf="visible" (click)="close()">
    <div class="demo-dialog-card" (click)="$event.stopPropagation()">
        <div class="demo-dialog-header">
            <h3>Add Demo Account</h3>
            <p>Create a demo account for the selected organization.</p>
        </div>

        <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="demo-form-grid">
                <div class="demo-field">
                    <label for="demoUserName">User Name <small>*</small></label>
                    <input id="demoUserName" class="demo-control" type="text" formControlName="userName"/>
                </div>
                <div class="demo-field">
                    <label for="demoEmail">Email <small>*</small></label>
                    <input id="demoEmail" class="demo-control" type="email" formControlName="email"/>
                </div>
                <div class="demo-field">
                    <label for="demoFirstName">First Name <small>*</small></label>
                    <input id="demoFirstName" class="demo-control" type="text" formControlName="firstName"/>
                </div>
                <div class="demo-field">
                    <label for="demoLastName">Last Name</label>
                    <input id="demoLastName" class="demo-control" type="text" formControlName="lastName"/>
                </div>
                <div class="demo-field">
                    <label for="demoRole">Role <small>*</small></label>
                    <select
                            id="demoRole"
                            class="demo-control demo-select"
                            [(ngModel)]="demoRole"
                            [ngModelOptions]="{standalone: true}">
                        <option value="staff">Demo Staff</option>
                        <option value="admin">Demo Admin</option>
                    </select>
                </div>
                <div class="demo-field">
                    <label for="demoExpiryDays">Expiry Days <small>*</small></label>
                    <select
                            id="demoExpiryDays"
                            class="demo-control demo-select"
                            [(ngModel)]="demoExpiryDays"
                            [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let days of demoExpiryOptions" [value]="days">{{ days }} Days</option>
                    </select>
                </div>
                <div class="demo-field demo-field-full">
                    <label for="demoOrganization">Organization <small>*</small></label>
                    <select
                            id="demoOrganization"
                            class="demo-control demo-select demo-org-select"
                            formControlName="organization"
                            [attr.title]="form.get('organization')?.value || ''">
                        <option *ngFor="let org of organizations" [value]="org.name" [attr.title]="org.name">
                            {{ org.name }}
                        </option>
                    </select>
                </div>
                <div class="demo-field">
                    <label for="demoMobileNumber">Phone Number <small>*</small></label>
                    <input id="demoMobileNumber" class="demo-control" type="text" formControlName="mobileNumber"/>
                </div>
            </div>

            <div class="demo-dialog-actions">
                <button type="button" class="demo-btn-cancel" (click)="close()" [disabled]="saving">
                    Cancel
                </button>
                <button type="submit" class="demo-btn-save" [disabled]="saving">
                    <fa-icon [icon]="['fas', 'square-check']"></fa-icon>
                    {{ saving ? 'Creating...' : 'Create Demo Account' }}
                </button>
            </div>
        </form>
    </div>
</div>
